import Calc from "@/common/util/calculator"
import BaseScrewFixmethod from "@/signomatic/app/fixmethods/base_screw"

export default class ScrewForexFixmethod extends BaseScrewFixmethod {
  positions() {
    const { shape, border, width, widthPx, height, heightPx } = this.state
    const diameter = Calc.mmToPx(4)
    const cappedScrew = this.state.fixmethod === "screw_capped"
    let headDiameter = Calc.mmToPx(7)
    const hasBorder = this.drawables.hasBorder
    const borderWidth = this.drawables.borderWidth
    const positions = []
    const centerV = heightPx / 2 - diameter / 2
    let distance = 0

    if (cappedScrew) {
      headDiameter = width > 399 || height > 399 ? Calc.mmToPx(15) : Calc.mmToPx(10)
    }

    const defaults = { diameter, headDiameter }

    if (["rect", "round"].includes(shape)) {
      const wideHorisontal = height > 499 && width > 999
      const wideVertical = width > 499 && height > 999
      const fourScrews = height >= 100
      const sixScrews = wideHorisontal || wideVertical

      if (shape === "rect") {
        if (sixScrews || (fourScrews && wideHorisontal)) {
          distance = Calc.mmToPx(12)
        } else if (fourScrews) {
          if (cappedScrew) {
            distance = hasBorder
              ? this.drawables.sizeRelative("height", Calc.mmToPx(11), Calc.mmToPx(15))
              : Calc.mmToPx(11)
          } else {
            distance = hasBorder
              ? this.drawables.sizeRelative("height", Calc.mmToPx(12), Calc.mmToPx(16))
              : Calc.mmToPx(11)
          }
        } else {
          if (cappedScrew) {
            distance = hasBorder
              ? this.drawables.sizeRelative("height", Calc.mmToPx(7), Calc.mmToPx(10))
              : Calc.mmToPx(7)
          } else {
            distance = hasBorder
              ? this.drawables.sizeRelative("height", Calc.mmToPx(9), Calc.mmToPx(12))
              : Calc.mmToPx(7)
          }
        }
      } else if (shape === "round") {
        if (sixScrews) {
          const relative = width === 1000 ? "height" : "width"
          const opts =
            width === 1000
              ? {
                  minHeight: 500,
                }
              : {
                  minWidth: 500,
                }
          distance =
            hasBorder && !cappedScrew
              ? this.drawables.sizeRelative(relative, Calc.mmToPx(37), Calc.mmToPx(60), opts)
              : this.drawables.sizeRelative(relative, Calc.mmToPx(30), Calc.mmToPx(50), opts)
        } else if (fourScrews) {
          if (wideHorisontal || wideHorisontal) {
            if (hasBorder && !cappedScrew) {
              distance = this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(37), {
                maxHeight: 500,
              })
            } else {
              distance = this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(30), {
                maxHeight: 500,
              })
            }
          } else {
            const widthOpts = {
              minWidth: 100,
              maxWidth: 500,
            }

            const heightOpts = {
              minHeight: 100,
              maxHeight: 500,
            }

            if (this.state.fixmethod === "screw") {
              if (width === 1000) {
                distance = hasBorder
                  ? this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(37), heightOpts)
                  : this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(30), heightOpts)
              } else if (height === 1000) {
                distance = hasBorder
                  ? this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(37), widthOpts)
                  : this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(30), widthOpts)
              } else {
                distance = hasBorder
                  ? this.drawables.sizeRelative("height", Calc.mmToPx(11), Calc.mmToPx(60), { minHeight: 100 })
                  : this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(50), { minHeight: 100 })
              }
            } else {
              distance = this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(50))
            }
          }
        } else {
          // two screws
          if (cappedScrew) {
            distance = Calc.mmToPx(7)
          } else {
            distance = hasBorder
              ? this.drawables.sizeRelative("height", Calc.mmToPx(9), Calc.mmToPx(12))
              : Calc.mmToPx(7)
          }
        }
      }

      const left = distance - diameter / 2
      const top = distance - diameter / 2
      const bottom = heightPx - distance - diameter / 2
      const right = widthPx - distance - diameter / 2
      const centerH = widthPx / 2 - diameter / 2

      if (fourScrews && border === "retro" && height >= 100 && height <= 149) {
        distance = this.drawables.sizeRelative("height", Calc.mmToPx(7.5), Calc.mmToPx(11), {
          minHeight: 100,
          maxHeight: 149,
        })
      }

      if (sixScrews) {
        positions.push({ ...defaults, left: centerH, top })
        positions.push({ ...defaults, left: centerH, top: bottom })
      }

      if (fourScrews || sixScrews) {
        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    } else if (shape === "rotated_rect") {
      distance =
        height < 100
          ? this.drawables.sizeRelative("height", Calc.mmToPx(9), Calc.mmToPx(11), { maxHeight: 100 })
          : this.drawables.sizeRelative("height", Calc.mmToPx(11), Calc.mmToPx(40), {
              minHeight: 100,
              maxHeight: 600,
            })
      if (cappedScrew) {
        distance =
          height < 100
            ? this.drawables.sizeRelative("height", Calc.mmToPx(9), Calc.mmToPx(12), { maxHeight: 100 })
            : this.drawables.sizeRelative("height", Calc.mmToPx(12), Calc.mmToPx(50), {
                minHeight: 100,
                maxHeight: 600,
              })
      }

      const center = widthPx / 2 - diameter / 2
      const top = distance - diameter / 2
      const bottom = heightPx - diameter / 2 - distance
      const left = distance - diameter / 2
      const right = widthPx - diameter / 2 - distance

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })

      if (height > 99) {
        positions.push({ ...defaults, left: center, top: top })
        positions.push({ ...defaults, left: center, top: bottom })
      }
    } else if (shape === "ellipse") {
      const fourScrews = height >= 600
      if (fourScrews) {
        distance = hasBorder
          ? this.drawables.sizeRelative("width", Calc.mmToPx(12), Calc.mmToPx(32))
          : this.drawables.sizeRelative("width", Calc.mmToPx(12), Calc.mmToPx(20))
      } else {
        distance = hasBorder
          ? this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(32))
          : this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(12))
      }

      const minTop = cappedScrew ? Calc.mmToPx(20) : Calc.mmToPx(13)
      const maxTop = cappedScrew ? Calc.mmToPx(25) : Calc.mmToPx(20)
      const distanceTop = this.drawables.sizeRelative("height", minTop, maxTop)

      const left = borderWidth + distance - diameter / 2
      const right = widthPx - borderWidth - diameter / 2 - distance
      const center = heightPx / 2 - diameter / 2
      const centerH = widthPx / 2 - diameter / 2
      const top = distanceTop - diameter / 2
      const bottom = heightPx - diameter / 2 - distance

      positions.push({ ...defaults, left, top: center })
      positions.push({ ...defaults, left: right, top: center })

      if (fourScrews) {
        positions.push({ ...defaults, left: centerH, top: top })
        positions.push({ ...defaults, left: centerH, top: bottom })
      }
    } else if (shape === "stop") {
      distance = hasBorder
        ? this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(32))
        : this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(12))

      const left = borderWidth + distance - diameter / 2
      const right = widthPx - borderWidth - diameter / 2 - distance
      const center = heightPx / 2 - diameter / 2

      positions.push({ ...defaults, left, top: center })
      positions.push({ ...defaults, left: right, top: center })
    } else if (["arrow_left", "arrow_right"].includes(shape)) {
      const minFront = cappedScrew ? Calc.mmToPx(12) : Calc.mmToPx(9)
      const maxFront = cappedScrew ? Calc.mmToPx(25) : Calc.mmToPx(hasBorder ? 19 : 15)
      const minBack = cappedScrew ? Calc.mmToPx(9) : Calc.mmToPx(hasBorder ? 9 : 7)
      const maxBack = cappedScrew ? Calc.mmToPx(hasBorder ? 20 : 14) : Calc.mmToPx(hasBorder ? 20 : 10)

      const distanceFront = this.drawables.sizeRelative("height", minFront, maxFront)
      const distanceBack = this.drawables.sizeRelative("height", minBack, maxBack)

      let left = borderWidth + distanceFront - diameter / 2
      let right = widthPx - borderWidth - diameter / 2 - distanceBack

      if (shape === "arrow_right") {
        left = borderWidth + distanceBack - diameter / 2
        right = widthPx - borderWidth - diameter / 2 - distanceFront

        positions.push({
          ...defaults,
          left: widthPx - borderWidth - diameter / 2 - distanceBack,
          top: centerV,
          stretch: true,
        })
      } else {
        positions.push({
          ...defaults,
          left: borderWidth + distanceBack - diameter / 2,
          top: centerV,
          stretch: true,
        })
      }

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (["direction_left", "direction_right"].includes(shape)) {
      let distanceFront = this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(18), { maxWidth: 600 })
      let distanceBack = this.drawables.sizeRelative("width", Calc.mmToPx(7), Calc.mmToPx(12), { maxWidth: 600 })

      if (this.state.fixmethod === "screw_capped") {
        distanceFront = this.drawables.sizeRelative("width", Calc.mmToPx(12), Calc.mmToPx(25))
        distanceBack = hasBorder
          ? this.drawables.sizeRelative("width", Calc.mmToPx(9), Calc.mmToPx(20))
          : this.drawables.sizeRelative("width", Calc.mmToPx(9), Calc.mmToPx(14))
      }

      let left = distanceFront - diameter / 2
      let right = widthPx - diameter / 2 - distanceBack

      if (shape === "direction_right") {
        left = distanceBack - diameter / 2
        right = widthPx - diameter / 2 - distanceFront

        positions.push({
          ...defaults,
          left: widthPx - diameter / 2 - distanceBack,
          top: centerV,
          stretch: true,
        })
      } else {
        positions.push({
          ...defaults,
          left: distanceBack - diameter / 2,
          top: centerV,
          stretch: true,
        })
      }

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (shape === "triangle") {
      const min = cappedScrew ? Calc.mmToPx(10) : Calc.mmToPx(6)
      const max = cappedScrew ? Calc.mmToPx(20) : Calc.mmToPx(hasBorder ? 20 : 11)
      distance = this.drawables.sizeRelative("height", min, max)

      const offset = Calc.triangleHorizontalOffset(widthPx, heightPx, distance)
      const minTop = cappedScrew ? Calc.mmToPx(15) : Calc.mmToPx(12.5)
      const maxTop = cappedScrew ? Calc.mmToPx(25) : Calc.mmToPx(hasBorder ? 23 : 15)
      const distanceTop = this.drawables.sizeRelative("height", minTop, maxTop)

      const center = widthPx / 2 - diameter / 2
      const top = distanceTop - diameter / 2
      const topStretch = distance - headDiameter / 2
      const bottom = heightPx - diameter / 2 - distance
      const left = offset + distance - diameter / 2
      const right = widthPx - offset - diameter / 2 - distance

      positions.push({ ...defaults, left: center, top })
      positions.push({ ...defaults, left, top: bottom })
      positions.push({ ...defaults, left: right, top: bottom })
      positions.push({ ...defaults, left: center, top: topStretch, stretch: true })
    } else if (["rounded_top", "rounded_sides", "curved_top", "arched_top"].includes(shape)) {
      const fourScrews = width >= 199
      const fourScrewOpts = { minWidth: 199, maxWidth: 600, minHeight: 199, maxHeight: 600 }
      let distanceSide = 0
      let distanceTop = 0

      if (fourScrews) {
        if (shape == "arched_top") {
          distanceSide = Calc.mmToPx(11)
          distanceTop = this.drawables.sizeRelative(
            "height",
            Calc.mmToPx(77),
            Calc.mmToPx(cappedScrew ? 222 : 218),
            fourScrewOpts
          )
        } else if (shape == "rounded_top") {
          distanceSide = cappedScrew ? Calc.mmToPx(11) : Calc.mmToPx(10)
          distanceTop = cappedScrew
            ? this.drawables.sizeRelative("height", Calc.mmToPx(26), Calc.mmToPx(72), fourScrewOpts)
            : this.drawables.sizeRelative("height", Calc.mmToPx(24), Calc.mmToPx(67), fourScrewOpts)
        } else if (shape == "rounded_sides") {
          distanceSide = this.drawables.sizeRelative(
            "width",
            Calc.mmToPx(27),
            Calc.mmToPx(cappedScrew ? 70 : 68),
            fourScrewOpts
          )
          distanceTop = cappedScrew ? Calc.mmToPx(11) : Calc.mmToPx(10)
        } else if (shape == "curved_top") {
          distance = this.drawables.sizeRelative("width", Calc.mmToPx(10), Calc.mmToPx(13), fourScrewOpts)
          const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(82), Calc.mmToPx(244), fourScrewOpts)

          const left = distance - diameter / 2
          const top = distance - diameter / 2
          const right = widthPx - distance - diameter / 2
          const bottom = heightPx - Calc.mmToPx(10) - diameter / 2

          positions.push({ ...defaults, left, top })
          positions.push({ ...defaults, left, top: bottom })
          positions.push({ ...defaults, left: right, top: curveTop })
          positions.push({ ...defaults, left: right, top: bottom })

          return positions
        }
      } else {
        distanceSide = Calc.mmToPx(9.5)
      }

      const left = distanceSide - diameter / 2
      const top = distanceTop - diameter / 2
      let bottom = heightPx - distanceTop - diameter / 2
      const right = widthPx - distanceSide - diameter / 2
      let centerV = widthPx / 2 - diameter / 2

      if (shape == "arched_top") {
        bottom = heightPx - distanceSide - diameter / 2

        if (fourScrews) {
          positions.push({
            ...defaults,
            left: widthPx / 2 - diameter / 2,
            top: diameter / 2,
            stretch: true,
          })
        } else {
          // arcH constant also in arched_top
          const arcH = heightPx * 0.35
          const squareHeight = heightPx - arcH
          centerV = arcH + squareHeight / 2 - diameter / 2
          positions.push({
            ...defaults,
            left: widthPx / 2 - diameter / 2,
            top: heightPx - centerV - diameter,
            stretch: true,
          })
        }
      }

      if (fourScrews) {
        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    }

    return positions
  }
}
